$(document).ready(function() {
    $('.site-header__menu').click(function(){
        if($('.logo-img').hasClass('logo-img-white')){
            $('.logo-img').attr('src','https://cdn.shopify.com/s/files/1/0358/6057/8437/files/logo-color_300x300.png');
            
            $('.logo-img').removeClass('logo-img-white');
          
          	$('#AccessibleNav').addClass('mobileOpen');
        }else{
            $('.logo-img').attr('src','https://cdn.shopify.com/s/files/1/0358/6057/8437/t/5/assets/logo-white_300x.png?v=7651844538640781980');

            $('.logo-img').addClass('logo-img-white');
          $('#AccessibleNav').removeClass('mobileOpen');
        }
      
    });
	
  	$('#Hero-161172126580101502').ripples({
        resolution: 512,
        dropRadius: 20,
        perturbance: 0.04,
    });
  	
    $('#Hero-1592553376857').ripples({
        resolution: 512,
        dropRadius: 20,
        perturbance: 0.04,
    });

    $('#featuredHome').lightSlider({
        item:3,
        loop:false,
        slideMove:2,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:600,
        responsive : [
            {
                breakpoint:800,
                settings: {
                    item:2,
                    slideMove:1,
                    slideMargin:6,
                  }
            },
            {
                breakpoint:480,
                settings: {
                    item:1,
                    slideMove:1
                  }
            }
        ]
    }); 
  
  	$('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});
  

  	if(navigator.cookieEnabled) {
      //thinbar announcement
      if(!$.cookie('thin_announcement')){
        $('.announcement-bar').css('display', 'block');
      }else{
        $('.announcement-bar').hide();
      }

      $('.announcement-bar #close').click(function()
      {
         $('.announcement-bar').hide();
        $.cookie('thin_announcement', 'is_closed', { expires: 1, path: '/'});
      });
    }
  
    //Age check modal and cookie
    //Expires after 7 days
    if(!$.cookie('age_check')){
        $('.age_check').show();
    }else{
        $('.age_check').hide();
     /*  
        if(!$.cookie('announcement')){
                
            setTimeout(function(){ 
                $('.announcement').show()    ;   
            }, 3000);     
        }else{
            $('.announcement').hide() 
        }  
      */
      
    }

    $('#enter').click(function(){
		/*
      setTimeout(function(){ 
        $('.announcement').show()    ;   
      }, 3000);      
		*/
      $('.age_check').hide();
      $.cookie('age_check', 'over18', { expires: 7, path: '/'});
      return false;
    });
    /*
    $('.announcement .button').click(function()
    {
        $.cookie('announcement', 'closed', { expires: 1, path: '/'});
    });
    
    $('.announcement a').click(function()
    {
        $.cookie('announcement', 'closed', { expires: 1, path: '/'});
    });
   
    $('.icon-close #close').click(function(){
        $('.announcement').hide();
        $.cookie('announcement', 'closed', { expires: 1, path: '/'});
    }); */

    $('#reset').click(function(){
        $.removeCookie('age_check', { path: '/' });
        $.removeCookie('announcement', { path: '/' });
        
        $('.age_check').show();
    });
    
    if ($(window).width() >= 1024) {
        if($('body').hasClass('template-index')){
        // Scroll
        var controller = new ScrollMagic.Controller();

        //MINT
        var tweenMint = new TimelineMax ()
            .add([
                TweenMax.fromTo(".mint-top", 1,  {css: {bottom: "50%"}}, {css: {bottom: "200%"}})
            ]);
        var durationMint = (document.querySelector('#our-story-wrapper').clientHeight)+200;
        // build scene
        var scene = new ScrollMagic.Scene({triggerElement: "#flyingSection", duration: durationMint})
            .setTween(tweenMint)
            // .addIndicators() // add indicators (requires plugin)
            .addTo(controller);

        //GrapeFruit
        var tweenGrape = new TimelineMax ()
            .add([
                TweenMax.fromTo(".grape-fruit", 1,  {css: {top: "120%"}}, {css: {top: "-20%"}})
            ]);
        var durationGrape = (document.querySelector('#our-story-wrapper').clientHeight)+500;
        // build scene
        var scene = new ScrollMagic.Scene({triggerElement: "#our-story-wrapper", duration: durationGrape})
            .setTween(tweenGrape)
            // .addIndicators() // add indicators (requires plugin)
            .addTo(controller);
        
        var durationCocktail = (document.querySelector('.cocktail .row').clientHeight);
       
        var tweenGrapePeel = new TimelineMax ()
        .add([
            TweenMax.fromTo(".grape-fruit-peel", 1,  {css: {top:"100%"}}, {css: {top:"0%"}})
        ]);
        var durationGrapePell = (document.querySelector('.cocktail .row').clientHeight)+300;
        var scene = new ScrollMagic.Scene({triggerElement: "#cocktail-wrapper", duration: durationGrapePell,offset: durationCocktail/3,})
        .setTween(tweenGrapePeel)
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);


        var leaves = new TimelineMax ()
        .add([
            TweenMax.fromTo(".leaf-focus", 1,  {css: {top:"0"}}, {css: {top:"-30%"}}),
            TweenMax.fromTo(".leaf-bokeh", 1,  {css: {top:"20%"}}, {css: {top:"-70%"}})
        ]);
        var durationLeaves = (document.querySelector('#cellar-door-wrapper').clientHeight);
        var scene = new ScrollMagic.Scene({triggerElement: "#cellar-door-wrapper", duration: durationLeaves, offset: -300})
        .setTween(leaves)
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);


        var berries = new TimelineMax ()
        .add([
            TweenMax.fromTo(".juniper-focus", 1,  {css: {top:"70%"}}, {css: {top:"-30%"}}),
            TweenMax.fromTo(".juniper-mid", 1,  {css: {top:"50%"}}, {css: {top:"-50%"}}),
            TweenMax.fromTo(".juniper-bokeh", 1,  {css: {top:"80%"}}, {css: {top:"-70%"}})

        ]);
        var durationBerries = (document.querySelector('#cellar-door-wrapper').clientHeight);
        var scene = new ScrollMagic.Scene({triggerElement: "#cellar-door-wrapper", duration:durationBerries})
        .setTween(berries)
        //  .addIndicators() // add indicators (requires plugin)
        .addTo(controller);

         /* 
        var parrallaxText= new TimelineMax ()
        .add([
            TweenMax.fromTo(".parallax-box-wrapper", 1,  {css: {top:"80%"}}, {css: {top:"0%"}})
        ]);
        var durationNewsletter = document.querySelector('.newsletter-block').clientHeight;
        var scene = new ScrollMagic.Scene({triggerElement: ".newsletter-block", duration:durationNewsletter})
        .setTween(parrallaxText)
        // .addIndicators() // add indicators (requires plugin)
        .addTo(controller);*/
          
        }

    }
}); 